var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"cta-section"},[_c('a',{staticClass:"button-link box-button",attrs:{"href":"https://app.mathtest.ninja/sign-up"}},[_vm._v(" Sign up today ")])])
}]

export { render, staticRenderFns }